import { Component, OnDestroy, OnInit } from '@angular/core';
import { SubSink } from 'subsink';
import { FollowingQuery } from './store/following/state/following.query';
import { FollowingStore } from './store/following/state/following.store';
import { SessionStore } from './store/session/state/session.store';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'LATCAS';
  subs = new SubSink();
  selectedVehiclePopupOpen: boolean;
  constructor(
    private followingQuery: FollowingQuery,
    private followingStore: FollowingStore,
    private sessionStore: SessionStore
  ) {}

  ngOnInit(): void {
    this.subs.sink = this.followingQuery
      .select()
      .subscribe((x) => (this.selectedVehiclePopupOpen = !!x.currentVechile));
    const token = localStorage.getItem('token');
    if (token) {
      this.sessionStore.update((x) => ({ ...x, token }));
    }
  }

  toogleSelectedVehiclePopup() {
    this.followingStore.update((state) => ({
      ...state,
      currentVechile: null,
      followCenterVehicle: false,
    }));
  }
  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
